module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_003_sm-fcb36805.png";